var $e042e75e71de1104$exports = {};
// AuzGroups: site behaviour. No animation libraries; motion lives in CSS.
/* Mark JS as live before first paint so reveal styles arm only when they can
   actually be undone. Without this a script failure hides the whole page. */ document.documentElement.classList.add("js");
const $e042e75e71de1104$var$REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)");
/* ---- Scroll reveal ------------------------------------------------------ */ (function reveal() {
    const items = document.querySelectorAll("[data-reveal]");
    if (!items.length) return;
    const showAll = ()=>items.forEach((el)=>el.classList.add("is-in"));
    if ($e042e75e71de1104$var$REDUCED.matches || !("IntersectionObserver" in window)) return showAll();
    const io = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (!entry.isIntersecting) return;
            entry.target.classList.add("is-in");
            io.unobserve(entry.target);
        });
    }, {
        rootMargin: "0px 0px -10% 0px",
        threshold: 0.12
    });
    items.forEach((el)=>io.observe(el));
    // Safety net: content must never stay hidden because an observer misfired.
    window.setTimeout(showAll, 3000);
})();
/* ---- Hero parallax ------------------------------------------------------ */ (function parallax() {
    const layer = document.querySelector(".hero");
    if (!layer || $e042e75e71de1104$var$REDUCED.matches) return;
    let ticking = false;
    const apply = ()=>{
        const y = window.scrollY;
        if (y < window.innerHeight * 1.2) layer.style.setProperty("--hero-shift", `${y * 0.18}px`);
        ticking = false;
    };
    window.addEventListener("scroll", ()=>{
        if (!ticking) {
            ticking = true;
            window.requestAnimationFrame(apply);
        }
    }, {
        passive: true
    });
    apply();
})();
/* ---- Nav: frost on scroll (rAF-throttled), mobile sheet ----------------- */ (function nav() {
    const bar = document.querySelector(".nav");
    if (!bar) return;
    let ticking = false;
    const sync = ()=>{
        bar.classList.toggle("is-scrolled", window.scrollY > 24);
        ticking = false;
    };
    window.addEventListener("scroll", ()=>{
        if (!ticking) {
            ticking = true;
            window.requestAnimationFrame(sync);
        }
    }, {
        passive: true
    });
    sync();
    const toggle = bar.querySelector(".nav__toggle");
    const sheet = bar.querySelector(".nav__sheet");
    if (!toggle || !sheet) return;
    toggle.addEventListener("click", ()=>{
        const open = toggle.getAttribute("aria-expanded") === "true";
        toggle.setAttribute("aria-expanded", String(!open));
        sheet.hidden = open;
        bar.classList.toggle("is-open", !open);
    });
    // Close the sheet when a destination is chosen, or on Escape.
    sheet.addEventListener("click", (e)=>{
        if (e.target.closest("a")) {
            toggle.setAttribute("aria-expanded", "false");
            sheet.hidden = true;
            bar.classList.remove("is-open");
        }
    });
    document.addEventListener("keydown", (e)=>{
        if (e.key === "Escape" && toggle.getAttribute("aria-expanded") === "true") {
            toggle.setAttribute("aria-expanded", "false");
            sheet.hidden = true;
            bar.classList.remove("is-open");
            toggle.focus();
        }
    });
})();
/* ---- Contact form via EmailJS ------------------------------------------ */ (function contactForm() {
    const form = document.getElementById("contactForm");
    if (!form || typeof emailjs === "undefined") return;
    const PUBLIC_KEY = "tJaLWhshQHae6MPm-";
    const SERVICE_ID = "service_0ts5s8k";
    const TEMPLATE_ID = "template_ign26is";
    emailjs.init(PUBLIC_KEY);
    const status = document.getElementById("form-status");
    const btn = document.getElementById("submit-btn");
    const idle = btn.textContent.trim();
    const say = (kind, text)=>{
        status.className = "form__status form__status--" + kind;
        status.textContent = text;
        status.hidden = false;
    };
    form.addEventListener("submit", (event)=>{
        event.preventDefault();
        btn.disabled = true;
        btn.textContent = "Sending\u2026";
        status.hidden = true;
        emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form, PUBLIC_KEY).then(()=>{
            form.reset();
            btn.disabled = false;
            btn.textContent = idle;
            say("ok", "Thanks, that's landed. We'll come back to you within one business day.");
        }, (error)=>{
            btn.disabled = false;
            btn.textContent = idle;
            say("err", "That didn't send. Email us directly at info@auzgroups.com or call +61 406 104 350.");
            console.error("EmailJS:", error);
        });
    });
})();
/* ---- Hero wave field ----------------------------------------------------
   Layered sine ribbons drawn as fine striations, additively blended so the
   crests glow against the dark ground. Colours come from the design tokens,
   so the palette stays the single source of truth.                        */ (function heroWaves() {
    const cv = document.querySelector(".hero__canvas");
    if (!cv) return;
    const ctx = cv.getContext("2d");
    if (!ctx) return;
    const cs = getComputedStyle(document.documentElement);
    const colours = [
        "--wave-c1",
        "--wave-c2",
        "--wave-c3"
    ].map((v)=>cs.getPropertyValue(v).trim()).filter(Boolean);
    if (colours.length < 3) return;
    // base/spread are fractions of hero height; amp/freq shape each ribbon
    // base/spread are fractions of hero height; the field is held to the lower
    // half so the headline sits on clean ground
    const BANDS = [
        // Thin ribbons with tall waves, stacked close. Because each ribbon is
        // nearly a single strand, they interleave rather than collide, which is
        // what lets the amplitude exceed the gap without reading as a mess.
        {
            c: 2,
            base: 0.80,
            spread: 0.016,
            amp: 0.105,
            freq: 0.80,
            speed: 0.10,
            lines: 20
        },
        {
            c: 0,
            base: 0.88,
            spread: 0.014,
            amp: 0.088,
            freq: 1.05,
            speed: 0.15,
            lines: 22,
            mirror: true
        },
        {
            c: 1,
            base: 0.95,
            spread: 0.013,
            amp: 0.074,
            freq: 1.35,
            speed: 0.21,
            lines: 22
        },
        {
            c: 2,
            base: 1.02,
            spread: 0.012,
            amp: 0.060,
            freq: 1.70,
            speed: 0.27,
            lines: 20
        }
    ];
    let w = 0, h = 0, raf = 0, t = 0, onScreen = true;
    // Ribbons gather at the bottom-left and open out to the right, held to a
    // band across the bottom 30% of the hero. No climb.
    const BASELINE = 0.9125; // shared centre line (fraction of hero height)
    const resize = ()=>{
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        const r = cv.getBoundingClientRect();
        w = Math.max(1, Math.round(r.width));
        h = Math.max(1, Math.round(r.height));
        cv.width = Math.round(w * dpr);
        cv.height = Math.round(h * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    const draw = ()=>{
        ctx.clearRect(0, 0, w, h);
        ctx.globalCompositeOperation = "lighter";
        ctx.lineWidth = 1;
        const step = w > 900 ? 4 : 6;
        for (const pass of [
            0,
            1
        ])for (const b of BANDS){
            ctx.strokeStyle = colours[b.c];
            ctx.lineWidth = pass === 0 ? 4 : 1;
            for(let i = 0; i < b.lines; i++){
                const u = i / (b.lines - 1);
                const off = h * (b.base - BASELINE + b.spread * (u - 0.5));
                // mirrored bands travel the opposite way
                const dir = b.mirror ? -1 : 1;
                const phase = t * b.speed * dir + u * 2.4;
                // lines toward the middle of a ribbon read as nearer: taller and brighter
                const depth = 0.30 + 0.70 * (1 - Math.abs(u - 0.5) * 2);
                ctx.globalAlpha = 0.05 + 0.17 * depth * depth;
                ctx.beginPath();
                for(let x = 0; x <= w; x += step){
                    const px = x / w; // true position, drives the sweep
                    // mirrored bands read the waveform from the far edge
                    const p = b.mirror ? 1 - px : px;
                    const yBase = h * BASELINE;
                    const A = h * b.amp * depth;
                    const y = yBase + off + Math.sin(p * Math.PI * b.freq + phase) * A + Math.sin(p * Math.PI * b.freq * 2.1 - phase * 1.3) * A * 0.22;
                    if (x === 0) ctx.moveTo(x, y);
                    else ctx.lineTo(x, y);
                }
                if (pass === 0) ctx.globalAlpha *= 0.32; // bloom pass is dimmer + wider
                ctx.stroke();
            }
        }
        ctx.globalAlpha = 1;
        ctx.globalCompositeOperation = "source-over";
    };
    const stop = ()=>{
        if (raf) {
            cancelAnimationFrame(raf);
            raf = 0;
        }
    };
    const frame = ()=>{
        t += 0.006;
        draw();
        raf = requestAnimationFrame(frame);
    };
    const start = ()=>{
        if (!raf && onScreen && !document.hidden && !$e042e75e71de1104$var$REDUCED.matches) frame();
    };
    resize();
    draw(); // one frame regardless, so it is never blank
    if (!$e042e75e71de1104$var$REDUCED.matches) start();
    let rt;
    window.addEventListener("resize", ()=>{
        clearTimeout(rt);
        rt = setTimeout(()=>{
            resize();
            draw();
        }, 150);
    }, {
        passive: true
    });
    // don't burn frames when the hero is scrolled away or the tab is backgrounded
    if ("IntersectionObserver" in window) new IntersectionObserver(([e])=>{
        onScreen = e.isIntersecting;
        onScreen ? start() : stop();
    }, {
        threshold: 0
    }).observe(cv);
    document.addEventListener("visibilitychange", ()=>document.hidden ? stop() : start());
    $e042e75e71de1104$var$REDUCED.addEventListener?.("change", ()=>$e042e75e71de1104$var$REDUCED.matches ? stop() : start());
})();
/* ---- Pinned capability sequence ----------------------------------------
   Three panels slide through a sticky stage. Panel i is centred when its
   segment value hits 0, off to the right below that, off to the left above.
   Everything is transform + opacity, driven from one rAF-throttled handler. */ (function pinnedPanels() {
    const pin = document.querySelector("[data-pin]");
    if (!pin) return;
    const stage = pin.querySelector(".pin__stage");
    const panels = [
        ...pin.querySelectorAll(".pin__panel")
    ];
    const dots = [
        ...pin.querySelectorAll(".pin__dots li")
    ];
    if (panels.length < 2) return;
    // matches the CSS bail-out: no pinning on narrow screens or reduced motion
    const off = window.matchMedia("(max-width: 60rem)");
    const isOff = ()=>off.matches || $e042e75e71de1104$var$REDUCED.matches;
    const clear = ()=>panels.forEach((el)=>{
            el.style.transform = "";
            el.style.opacity = "";
        });
    let ticking = false;
    const apply = ()=>{
        ticking = false;
        if (isOff()) return;
        const rect = pin.getBoundingClientRect();
        const travel = rect.height - stage.offsetHeight;
        if (travel <= 0) return;
        // The stage sticks at top:var(--nav-h), not at 0, so progress must be
        // measured from that offset. Measuring from 0 leaves p short of 1 by
        // stickyTop/travel, and the last panel never finishes centring before the
        // stage releases.
        const stickyTop = parseFloat(getComputedStyle(stage).top) || 0;
        const p = Math.min(1, Math.max(0, (stickyTop - rect.top) / travel));
        const last = panels.length - 1;
        // Panels travel 100% + GAP, so a clear gutter opens between the outgoing
        // panel and the incoming one instead of them butting edge to edge.
        const GAP = 18;
        panels.forEach((el, i)=>{
            const seg = p * last - i; // 0 = centred, +1 = gone left, -1 = waiting right
            // slight ease-in: holds near centre, then pushes away decisively
            const eased = Math.sign(seg) * Math.pow(Math.abs(seg), 1.25);
            const x = -eased * (100 + GAP);
            // Complementary crossfade: the outgoing panel loses exactly what the
            // incoming one gains, so the stage never dims overall, and anything a
            // full step away from centre is at 0; out of focus means invisible.
            const o = Math.max(0, 1 - Math.abs(seg));
            el.style.transform = `translate3d(${x}%, 0, 0)`;
            el.style.opacity = o.toFixed(3);
            el.setAttribute("aria-hidden", o < 0.5 ? "true" : "false");
            // the centred panel plays its visual; the others reset so it replays
            el.classList.toggle("is-active", Math.abs(seg) < 0.4);
        });
        const active = Math.round(p * last);
        dots.forEach((d, i)=>d.classList.toggle("is-on", i === active));
    };
    const onScroll = ()=>{
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(apply);
        }
    };
    window.addEventListener("scroll", onScroll, {
        passive: true
    });
    window.addEventListener("resize", ()=>{
        clear();
        onScroll();
    }, {
        passive: true
    });
    off.addEventListener?.("change", ()=>{
        clear();
        onScroll();
    });
    $e042e75e71de1104$var$REDUCED.addEventListener?.("change", ()=>{
        clear();
        onScroll();
    });
    apply();
})();
/* ---------------------------------------------------------- CACXI chat ---
   Book CTAs are buttons: their only job is to open the chat. The "Talk about"
   links keep their href, so they still reach contact if the widget never loads. */ (()=>{
    const OPEN = [
        "Book me now",
        true,
        true,
        true,
        true
    ];
    document.addEventListener("click", (e)=>{
        const el = e.target.closest("[data-book]");
        if (!el || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        const open = window.cacxi && window.cacxi.openChat;
        if (typeof open === "function") {
            e.preventDefault();
            window.cacxi.openChat(...OPEN);
            return;
        }
        // widget unavailable: a link falls through to its href, a button has none
        if (!el.hasAttribute("href")) {
            e.preventDefault();
            window.location.href = "contact.html";
        }
    });
})();


//# sourceMappingURL=index.24ba715c.js.map
